import { render, staticRenderFns } from "./IssueSolvingItemSmall.vue?vue&type=template&id=f5dd8116"
import script from "./IssueSolvingItemSmall.vue?vue&type=script&lang=ts"
export * from "./IssueSolvingItemSmall.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports